import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client';
import { NavigationProvider } from './contexts/NavigationContext';
import { PopupProvider } from './contexts/PopupContext';
import NavBar from './components/NavBar';
import Students from './pages/Students';
import Subjects from './pages/Subjects';
import Payments from './pages/Payments';
import Attendance from './pages/Attendance';
import Student from './forms/Student';
import Subject from './forms/Subject';
import styled from 'styled-components';
import GlobalStyles from './GlobalStyles';
import client from './apolloClient';
import MarkAttendance from './pages/MarkAttendance';
import LoginPopup from './forms/LoginPopup';

const Body = styled.div`
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  font-family: "Open Sans", sans-serif;
  font-weight: 300;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Wrapper = styled.div`
  padding: 30px;
  width: 100%;
  height: 100%;
  background-color: var(--background-color);
  color: var(--font-on-background-color);
  overflow-y: auto;
  @media (max-width: 1000px) {
    display: block;
    position: absolute;
    top: 0px;
    right: 0px;
    z-index: 0;
    padding:5px;
  }
`;

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const checkToken = () => {
      const token = localStorage.getItem('token');
      setIsLoggedIn(!!token);
    };

    // Initial check on component mount
    checkToken();

    // Add an event listener to track changes to localStorage
    window.addEventListener('storage', checkToken);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('storage', checkToken);
    };
  }, []);

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
  };

  const location = useLocation();

  if (!isLoggedIn && location.pathname !== '/registroasistencia') {
    return (
      <>
        <GlobalStyles />
        <LoginPopup onLoginSuccess={handleLoginSuccess} />
      </>
    );
  }

  return (
    <ApolloProvider client={client}>
      <NavigationProvider initialPage={'students'}>
        <PopupProvider>
          <GlobalStyles />
          <Body>
            <NavBar />
            <Wrapper>
              <Routes>
                <Route index element={<Students />} />
                <Route path="/students" element={<Students />} />
                <Route path="/subjects" element={<Subjects />} />
                <Route path="/payments" element={<Payments />} />
                <Route path="/attendance" element={<Attendance />} />
                <Route path="/student/:id" element={<Student />} />
                <Route path="/subject/:id" element={<Subject />} />
                <Route path="/registroAsistencia" element={<MarkAttendance />} />
              </Routes>
            </Wrapper>
          </Body>
        </PopupProvider>
      </NavigationProvider>
    </ApolloProvider>
  );
};

const AppWrapper = () => (
  <Router>
    <App />
  </Router>
);

export default AppWrapper;
